import { Component, OnInit } from '@angular/core';
import { Utilservice } from '@core/services/util.service';
import { ClientesService } from '@modules/clientes/services/clientes.service';
import { RequestWithFetchStatus } from '@shared/utils/request-with-fetch-status';
import * as moment from 'moment';
import * as toastr from 'toastr'

// Definição da classe Produto
class CidadeObj {
  constructor(
    public id: number,
    public nome: string,
    public selecionado: number
  ) {}
}

@Component({
  selector: 'app-relatorio-vendas',
  templateUrl: './relatorio-vendas.component.html',
  styleUrls: ['./relatorio-vendas.component.css']
})
export class RelatorioVendasComponent implements OnInit {

  isRequesting: boolean = false;

  userLogado;

  parameters: any;
  parameters2: any;

  lsStatusVisita: any[] = [];

  lsClients: any[] = [];
  lsCities:  any[] = [];

  cidades = [
    // { id: 1, nome: 'Belford roxo', selecionado: false },
    // { id: 2, nome: 'Nova Iguaçu', selecionado: false },
    // { id: 3, nome: 'São João de Meriti', selecionado: false },
    // Adicione mais itens conforme necessário
  ];

  cidade;

  nomeaaaa;

  exportRequest = new RequestWithFetchStatus<any>()

  constructor(private clientService: ClientesService,) { }

  ngOnInit() {

    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.parameters = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : '',
      fzs: "",
      anoInicial: "",
      anoFinal: "",
      tcComercio: "",
      cidade: "",
      clienteSemMovimento: null,
      mesAnoInicial: "",
      mesAnoFinal: "",
      mesInicial: "",
      mesFinal: "",
      compMes: ""
    };

    this.parameters2 = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : '',
      fzs: "",
      anoInicial: "",
      anoFinal: "",
      tcComercio: "",
      cidade: "",
      clienteSemMovimento: null,
      mesAnoInicial: "",
      mesAnoFinal: "",
      mesInicial: "",
      mesFinal: "",
      compMes: "",
      nomeCidade: ""
    };

    if(this.userLogado.perfil == 1){
      this.parameters.fzs = this.userLogado.setor;

      this.getCidades();

      this.parameters.tcComercio = '0';
    }

  }

  getRelatorio(){
    this.isRequesting = true;

    this.nomeaaaa = "";

    if(this.parameters.fzs == ""){
      toastr.error('Campo "FZS" Obrigatório');

      return this.isRequesting = false;
    }

    if(this.parameters.anoInicial == ""){
      toastr.error('Campo "Ano Inicial" Obrigatório');
      
      return this.isRequesting = false;
    }

    if(this.parameters.anoFinal == ""){
      toastr.error('Campo "Ano Final" Obrigatório');
      
      return this.isRequesting = false;
    }

    if(this.parameters.clienteSemMovimento != null){
      if(this.parameters.clienteSemMovimento != false){
        if(this.parameters.mesAnoInicial == "" || this.parameters.mesAnoFinal == ""){
          toastr.error('Campos "Mês Ano Inicial e Mês Ano Final" Obrigatório');
        
          return this.isRequesting = false;
        }
      }
    }

    if(this.parameters.mesAnoInicial != "" || this.parameters.mesAnoFinal != ""){
      if(this.parameters.clienteSemMovimento == "" || this.parameters.clienteSemMovimento == null){
        toastr.error('Check "Clientes S/ Movimento no Período" Obrigatório');
      
        return this.isRequesting = false;
      }
    }

    if(this.parameters.compMes != ""){
      if(this.parameters.mesInicial == "" || this.parameters.mesFinal == ""){
        toastr.error('Campos "Mês Inicial e Mês Final" Obrigatório');
      
        return this.isRequesting = false;
      }
    }

    if(this.parameters.mesInicial != "" || this.parameters.mesFinal != ""){
      if(this.parameters.compMes == ""){
        toastr.error('Check "Comparar Meses" Obrigatório');
      
        return this.isRequesting = false;
      }
    }

    // if(this.parameters.fzs != ""){
    //   toastr.error('Campo "FZS" Obrigatório');
      
    //   return this.isRequesting = false;
    // }
    // if(this.parameters.fzs != ""){
    //   toastr.error('Campo "FZS" Obrigatório');
      
    //   return this.isRequesting = false;
    // }

    this.clientService
        .getRelatorio(
          this.parameters.fzs,
          this.parameters.anoInicial,
          this.parameters.anoFinal,
          this.parameters.tcComercio,
          this.parameters.cidade,
          this.parameters.clienteSemMovimento,
          this.parameters.mesAnoInicial,
          this.parameters.mesAnoFinal,
          this.parameters.mesInicial,
          this.parameters.mesFinal,
          this.parameters.compMes

        )
        .subscribe(
          data => {
            this.isRequesting = false;

            this.lsClients = data;
          },
          error => console.log(error)
        );
  }

  getCidades(){

    if(this.parameters.fzs != ""){

      if(this.parameters.fzs.length == 6){
        this.clientService.getCidades(this.parameters.fzs).subscribe(
          data => {
            this.cidades = data;
            // this.vendedorLoading = false;
        },
          error => console.log(error)
        );
      }
    }
  }

  handleExport(){
    
    if(this.lsClients.length > 0)
    {
      var count = 0;
      this.exportRequest.get(
        this.clientService.exportRelVendasPorCidade(this.parameters.fzs,
          this.parameters.anoInicial,
          this.parameters.anoFinal,
          this.parameters.tcComercio,
          this.parameters.cidade,
          this.parameters.clienteSemMovimento,
          this.parameters.mesAnoInicial,
          this.parameters.mesAnoFinal,
          this.parameters.mesInicial,
          this.parameters.mesFinal,
          this.parameters.compMes)
      ).subscribe(
        response => {
          count++;
          if(count > 1)return;
          Utilservice.exportToFile(
            response.blob(),
            `exportacao-carteira-clientes setor-${moment().format('DD/MM/YYYY HH:mm:ss')}.pdf`, 'application/pdf'
          )
        }
      )
    }
    else
    {
      toastr.error('Consulte o relatório primeiro!');
    }
    
  }

  limpar(){
    this.parameters.fzs = this.userLogado.perfil !== 3 ? this.userLogado.setor : ''
    this.parameters.anoInicial = "";
    this.parameters.anoFinal = "";
    this.parameters.tcComercio = "";
    this.parameters.cidade = "";
    this.parameters.clienteSemMovimento = false;
    this.parameters.mesAnoInicial = "";
    this.parameters.mesAnoFinal = "";
  }

  verTodosClientesDaCidade(cidade: Text) {
    console.log('ID selecionado:', cidade);
    // Faça algo com o ID selecionado, como armazená-lo em uma variável
    if(this.parameters.fzs != ""){

      if(this.parameters.fzs.length == 6){
        this.clientService.getCidadeGrid(this.parameters.fzs, cidade).subscribe(
          data => {
            this.cidade = data;
            // this.vendedorLoading = false;

            this.parameters.cidade = this.cidade.id;

            this.handleExport();
        },
          error => console.log(error)
        );
      }
    }
  }

}
